module.exports = __webpack_public_path__ + "static/media/WeatherPlus_Profile_EN.da1df3b9.pdf";